/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class SessionApi extends runtime.BaseAPI {
    /**
     * An endpoint for checking if the current session is the latest session. Frontend should periodically call this endpoint to check if it has the latest session.
     * Session Ping
     */
    async v1PingSessionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/session/ping`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * An endpoint for checking if the current session is the latest session. Frontend should periodically call this endpoint to check if it has the latest session.
     * Session Ping
     */
    async v1PingSession(initOverrides) {
        const response = await this.v1PingSessionRaw(initOverrides);
        return await response.value();
    }
    /**
     * Update the latest session. The backend memorizes the access token used to update the session, only allowing the client with the token to be logged in.  The frontend has to acquire a session through this endpoint before accessing other endpoints.
     * Update Session
     */
    async v1UpdateSessionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v1/session`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Update the latest session. The backend memorizes the access token used to update the session, only allowing the client with the token to be logged in.  The frontend has to acquire a session through this endpoint before accessing other endpoints.
     * Update Session
     */
    async v1UpdateSession(initOverrides) {
        const response = await this.v1UpdateSessionRaw(initOverrides);
        return await response.value();
    }
}
